'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var SearchSummaryService = function SearchSummaryService(criteriaRuleService, criteriaRuleDataService, momentService, $filter) {
  var hierarchies = require('./../config/summary-hierarchy.json');
  var denyingOperators = ['Is Not', 'Not Between', '!='];
  var operatorMapping = require('./../config/operatorMapping.json');
  var DOW_VALUE_TYPE = 'dow';
  var TEXT_TYPE = 'text';
  var ALL_VALUE = 'All';
  var rmMomentFormat = $filter('rmMomentFormat');
  function getHighestRule(hierarchy, searchRules) {
    var highest;
    _.forEach(hierarchy, function (criterionName) {
      highest = _.find(searchRules, function (rule) {
        return rule.criterion === criterionName && denyingOperators.indexOf(rule.operator) === -1;
      });
      return !highest;
    });
    return highest;
  }
  function getHighestValue(screen, type, searchRules) {
    var hierarchy = hierarchies[screen][type];
    var highest = getHighestRule(hierarchy, searchRules);
    var result = {
      operator: '',
      value: null,
      isDate: false
    };
    if (highest) {
      result.isDate = momentService.isMoment(highest.leftOperand);
      if (_.isArray(highest.leftOperand)) {
        result.value = highest.leftOperand[0];
      } else if (highest.leftOperand && highest.rightOperand) {
        result.value = [highest.leftOperand, highest.rightOperand];
      } else {
        result.value = highest.leftOperand;
        var operator = operatorMapping[highest.operator];
        if (operator === undefined) {
          result.operator = highest.operator;
        } else {
          result.operator = operator;
        }
      }
    }
    return result;
  }
  function isEverythingSelected(rule, visibleRule) {
    var criteriaNameForData = criteriaRuleService.getCriteriaNameForData(rule.searchContext, rule.category, rule.criterion);
    var data = criteriaRuleDataService.getOperandData(criteriaNameForData || rule.criterion, rule.operator, visibleRule.valueType);
    return data && data.length === rule.leftOperand.length || visibleRule.valueType === DOW_VALUE_TYPE && rule.leftOperand.length === 7;
  }
  function getOperator(rule) {
    var mappedOperator = operatorMapping[rule.operator];
    if (mappedOperator === undefined) {
      return rule.operator;
    } else {
      return mappedOperator;
    }
  }
  function buildVisibleRule(rule) {
    var visibleRule = {};
    visibleRule.name = rule.shortCriterionName;
    visibleRule.operator = getOperator(rule);
    visibleRule.valueType = criteriaRuleService.getValueType(rule.searchContext, rule.level, rule.category, rule.criterion, rule.operator);
    if (_.isArray(rule.leftOperand)) {
      if (isEverythingSelected(rule, visibleRule)) {
        visibleRule.leftOperand = ALL_VALUE;
        visibleRule.valueType = TEXT_TYPE;
      } else {
        visibleRule.leftOperand = formatVisibleRule(_.cloneDeep(rule.leftOperand), rule.criterion);
      }
    } else {
      visibleRule.leftOperand = formatVisibleRule(_.cloneDeep(rule.leftOperand), rule.criterion);
      visibleRule.rightOperand = rule.rightOperand;
    }
    return visibleRule;
  }
  function getVisibleRules(searchRules) {
    return _.transform(searchRules, function (result, rule) {
      if (rule.isHidden !== true) {
        result.push(buildVisibleRule(rule));
      }
    });
  }
  function formatVisibleRule(rule, criterion) {
    var formats = {
      'Opt Week': function Opt_Week(rule) {
        if ((0, _typeof2["default"])(rule) === 'object') {
          return rule.dropdownVisibleValue;
        } else {
          return rmMomentFormat(momentService.of(rule, momentService.FIELD.DEPARTURE_DATE), 'MONTH_DAY');
        }
      },
      'Default': function Default(rule) {
        return rule;
      }
    };
    var formatter;
    if (Array.isArray(rule)) {
      for (var index = 0, ruleLength = rule.length; index < ruleLength; index++) {
        formatter = formats[criterion] || formats.Default;
        rule[index] = formatter(rule[index]);
      }
      return rule;
    } else {
      formatter = formats[criterion] || formats.Default;
      return formatter(rule);
    }
  }
  return {
    getHighestValue: getHighestValue,
    getVisibleRules: getVisibleRules
  };
};
SearchSummaryService.$inject = ['CriteriaRuleService', 'CriteriaRuleDataService', 'MomentService', '$filter'];
module.exports = SearchSummaryService;